import React from 'react';

import { IBaseProps, OnClick } from '@rbi-ctg/frontend';
import { IOffer } from '@rbi-ctg/menu';
import { IOfferFeedbackEntryFragment } from 'generated/rbi-graphql';

import OfferLayout from './layout';
import { useOffer } from './use-offer';

interface IOfferProps extends IBaseProps {
  offer: IOffer;
  offerFeedback: IOfferFeedbackEntryFragment | null;
  onClick: OnClick;
}

const Offer: React.FC<IOfferProps> = ({ className = '', offer, offerFeedback, onClick }) => {
  const { id, isNewOffer, endingIn, platforms, displayLoginRequiredBadge, state } = useOffer({
    offer,
    offerFeedback,
  });

  return (
    <OfferLayout
      id={id}
      isNewOffer={isNewOffer}
      className={className}
      offer={offer}
      onClick={onClick}
      endingIn={endingIn}
      platforms={platforms}
      displayLoginRequiredBadge={displayLoginRequiredBadge}
      state={state}
    />
  );
};

export default Offer;
